export const STEP_TITLE_CLASS = 'm-0 font-manrope text-[22px] font-extrabold text-[#1a1a1c]';
export const FIELD_LABEL_CLASS = 'font-manrope text-xs font-bold uppercase tracking-[0.5px] text-[#76767f]';
export const FIELD_BOX_CLASS =
  'flex h-11 w-full items-center gap-2.5 rounded-[10px] border border-[#e4e4e7] bg-[#fafafa] px-3.5';
export const FIELD_INPUT_CLASS =
  'min-w-0 flex-1 border-none bg-transparent p-0 font-manrope text-base text-[#1a1a1c] outline-none';
export const HINT_CLASS = 'm-0 font-manrope text-[13px] text-[#76767f]';
export const PRIMARY_BUTTON_CLASS =
  'flex h-[50px] w-full items-center justify-center rounded-[10px] border-none bg-[#252528] px-6 font-manrope text-sm font-bold text-white disabled:opacity-50';
export const TEXT_BUTTON_CLASS =
  'w-full border-none bg-transparent p-0 text-center font-manrope text-sm font-bold text-[#1a1a1c] disabled:opacity-50';
export const ERROR_TEXT_CLASS = 'm-0 font-manrope text-sm text-red-600';
